import React from 'react';

const OutlinedButton = ({ icon, onClick, isSelected }) => {
  return (
    <div
      onClick={onClick}
      style={{
        background: isSelected ? '#EFF0F7' : null,
        borderRadius: '8px',
        display: 'flex',
        height: '40px',
        width: '40px'
      }}
    >
      <img alt="cart" height="20px" src={icon} style={{ margin: 'auto' }} width="20px" />
    </div>
  );
};

export default OutlinedButton;
